import Register from "@/features/auth/register";

const RegisterPage = () => {
  return <Register />;
};

export default RegisterPage;
